"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageEndpointOut = void 0;
class MessageEndpointOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return MessageEndpointOut.attributeTypeMap;
    }
}
exports.MessageEndpointOut = MessageEndpointOut;
MessageEndpointOut.discriminator = undefined;
MessageEndpointOut.attributeTypeMap = [
    {
        "name": "channels",
        "baseName": "channels",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "createdAt",
        "baseName": "createdAt",
        "type": "Date",
        "format": "date-time"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string",
        "format": ""
    },
    {
        "name": "disabled",
        "baseName": "disabled",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "filterTypes",
        "baseName": "filterTypes",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "string",
        "format": ""
    },
    {
        "name": "nextAttempt",
        "baseName": "nextAttempt",
        "type": "Date",
        "format": "date-time"
    },
    {
        "name": "rateLimit",
        "baseName": "rateLimit",
        "type": "number",
        "format": "uint16"
    },
    {
        "name": "status",
        "baseName": "status",
        "type": "MessageStatus",
        "format": ""
    },
    {
        "name": "uid",
        "baseName": "uid",
        "type": "string",
        "format": ""
    },
    {
        "name": "updatedAt",
        "baseName": "updatedAt",
        "type": "Date",
        "format": "date-time"
    },
    {
        "name": "url",
        "baseName": "url",
        "type": "URI",
        "format": "uri"
    },
    {
        "name": "version",
        "baseName": "version",
        "type": "number",
        "format": "int32"
    }
];
//# sourceMappingURL=MessageEndpointOut.js.map